module.exports = "/_next/static/images/game-1-phone-gallery-08-26-1415-3e63c3045057b7ed20ea8d82a17614f9.jpg";